import { render, staticRenderFns } from "./transferBalanceRecord.vue?vue&type=template&id=8a48e2f8&scoped=true&"
import script from "./transferBalanceRecord.vue?vue&type=script&lang=js&"
export * from "./transferBalanceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a48e2f8",
  null
  
)

export default component.exports